import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DashboardLayout, BaseLayout } from "@layouts/index";
import { useSessionStorage } from "../../hooks";
import { getAllPropertyReviews } from "@services/krent.service";
import { formatDateTime } from "@utils/helpers";

export const AllReviewsPage = () => {
  const [user] = useSessionStorage("user", {});
  const [reviews, setReviews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();
  console.log(id, "id");
  useEffect(() => {
    if (!id) return;

    const controller = new AbortController();
    setLoading(true);
    setError(null);

    getAllPropertyReviews(id, 1, 20, controller.signal)
      .then((data: any) => {
        console.log(data, "data");
        if (data?.data) {
          setReviews(data.data);
        } else {
          setReviews([]);
        }
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load reviews.");
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [id]);
  console.log(reviews, "reviews");

  const content = (
    <AllReviews reviews={reviews} loading={loading} error={error} />
  );

  return user && user?.id ? (
    <DashboardLayout>{content}</DashboardLayout>
  ) : (
    <BaseLayout>{content}</BaseLayout>
  );
};

function AllReviews({
  reviews,
  loading,
  error,
}: {
  reviews: any[];
  loading: boolean;
  error: string | null;
}) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 6;

  if (loading) {
    return (
      <div className="container p-4 bg-white rounded my-4 text-center">
        <p>Loading reviews...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container p-4 bg-white rounded my-4 text-center text-danger">
        <p>{error}</p>
      </div>
    );
  }

  if (!reviews || reviews.length === 0) {
    return (
      <div className="container p-4 bg-white rounded my-4 text-center">
        <p>No reviews yet.</p>
      </div>
    );
  }

  const totalPages = Math.ceil(reviews.length / reviewsPerPage);
  const startIndex = (currentPage - 1) * reviewsPerPage;
  const currentReviews = reviews.slice(startIndex, startIndex + reviewsPerPage);

  return (
    <div className="container p-4 bg-white rounded my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-semibold">All Reviews</h6>
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate(-1)}
        >
          <i className="iconly-Arrow-Left icbo me-2"></i> Back
        </button>
      </div>

      <div className="row g-3">
        {currentReviews.map((r, index) => (
          <div key={index} className="col-md-4 p-2">
            <div className="border rounded-4 p-3 h-100">
              <div>
                <span className="fw-semibold">
                  {r?.user
                    ? (
                        `${r.user.firstname || ""} ${r.user.lastname || ""}`.trim() ||
                        r.user.preferredName ||
                        r.user.name ||
                        "Anonymous"
                      )
                    : "Anonymous"}
                </span>
              </div>
              <small className="text-muted">
                {formatDateTime(r.createdAt)}
              </small>
              <div className="d-flex my-4">
                {[...Array(5)].map((_, i) => {
                  const starValue = i + 1;
                  const rating = r.rating || 0;

                  if (starValue <= rating) {
                    return (
                      <i
                        key={i}
                        className="iconly-Star icbo me-1 text-warning"
                      ></i>
                    );
                  } else {
                    return (
                      <i
                        key={i}
                        className="iconly-Star icbo me-1"
                        style={{
                          color: "transparent",
                          WebkitTextStroke: "1px #47BBA9",
                        }}
                      ></i>
                    );
                  }
                })}
              </div>
              <p className="text-muted mb-2 fs-12">{r.review || ""}</p>
            </div>
          </div>
        ))}
      </div>

      <nav>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Previous
            </button>
          </li>

          {Array.from({ length: totalPages }).map((_, i) => (
            <li
              key={i}
              className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
